import { Controller, useFormContext } from 'react-hook-form';
import { CollapsibleSection } from '../primitives/CollapsibleSection';
import { ToggleRow } from '../primitives/ToggleRow';
import { useSectionOpenState } from '../../lib/useSectionOpenState';
import * as styles from './InAppPurchaseSection.css';
import { ProgramFormValues } from '../../model/programForm.types';

export type InAppPurchaseSectionProps = {
  isSubmitting?: boolean;
};

export const InAppPurchaseSection = ({
  isSubmitting,
}: InAppPurchaseSectionProps) => {
  const { control } = useFormContext<ProgramFormValues>();
  const { isOpen, setIsOpen } = useSectionOpenState();

  return (
    <CollapsibleSection
      title="In-app purchase"
      isOpen={isOpen}
      onOpenChange={setIsOpen}
    >
      <div className={styles.description}>
        <p>
          <strong>
            <u>Off</u>
          </strong>{' '}
          - Program is visible only by users with access to it. Won&apos;t be
          displayed on the list on default.
        </p>
        <p>
          <strong>
            <u>On</u>
          </strong>{' '}
          - Program is always displayed on the program list. Users with no
          access will encounter a paywall.
        </p>
      </div>
      <Controller
        control={control}
        name="inAppPurchaseAllowed"
        render={({ field }) => (
          <ToggleRow
            label="Turn on"
            checked={field.value}
            onChange={field.onChange}
            ariaLabel="In-app purchase"
            disabled={isSubmitting}
            testId="program-form-in-app-purchase"
          />
        )}
      />
    </CollapsibleSection>
  );
};
